module.exports = __webpack_public_path__ + "static/img/9.2914c558.jpg";